import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.17647,451.764706 L1468.29412,451.764706 L1468.29412,0 L1355.35294,0 L1355.35294,451.764706 L790.647059,451.764706 L790.647059,0 L677.705882,0 L677.705882,451.764706 L451.823529,451.764706 L338.882353,451.764706 L338.882353,564.705882 L451.823529,564.705882 L451.823529,734.117647 C451.823529,1014.32471 679.851765,1242.35294 960.058824,1242.35294 L1016.52941,1242.35294 L1016.52941,1637.64706 C1016.52941,1731.04941 940.52,1807.05882 847.117647,1807.05882 C753.715294,1807.05882 677.705882,1731.04941 677.705882,1637.64706 C677.705882,1482.01412 550.985882,1355.29412 395.352941,1355.29412 C239.72,1355.29412 113,1482.01412 113,1637.64706 L113,1920 L225.941176,1920 L225.941176,1637.64706 C225.941176,1544.24471 301.950588,1468.23529 395.352941,1468.23529 C488.755294,1468.23529 564.764706,1544.24471 564.764706,1637.64706 C564.764706,1793.28 691.484706,1920 847.117647,1920 C1002.75059,1920 1129.47059,1793.28 1129.47059,1637.64706 L1129.47059,1242.35294 L1185.94118,1242.35294 C1466.14824,1242.35294 1694.17647,1014.32471 1694.17647,734.117647 L1694.17647,564.705882 L1807.11765,564.705882 L1807.11765,451.764706 L1694.17647,451.764706 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLtiSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconLtiSolid, _Component);

  var _super = _createSuper(IconLtiSolid);

  function IconLtiSolid() {
    _classCallCheck(this, IconLtiSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconLtiSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLti",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLtiSolid.displayName = "IconLtiSolid";
  return IconLtiSolid;
}(Component);

IconLtiSolid.glyphName = 'lti';
IconLtiSolid.variant = 'Solid';
IconLtiSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLtiSolid;
export { IconLtiSolid };